// extracted by mini-css-extract-plugin
export default {"root":"hand-left_root__xRG2D"};